type Props = {
  title: string;
  body: string;
};

export function EmptyState({ title, body }: Props) {
  return (
    <div className="rounded-xl border border-dashed border-[var(--border)] bg-white/60 px-5 py-10 text-center">
      <h2 className="font-display text-xl text-dome-forest">{title}</h2>
      <p className="mx-auto mt-2 max-w-md text-sm text-[var(--muted)]">{body}</p>
    </div>
  );
}
